/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntermediaryClientPlanDetail } from './IntermediaryClientPlanDetail';
import {
    IntermediaryClientPlanDetailFromJSON,
    IntermediaryClientPlanDetailFromJSONTyped,
    IntermediaryClientPlanDetailToJSON,
} from './IntermediaryClientPlanDetail';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfListOfIntermediaryClientPlanDetail
 */
export interface ResultOfListOfIntermediaryClientPlanDetail {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfListOfIntermediaryClientPlanDetail
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfIntermediaryClientPlanDetail
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfIntermediaryClientPlanDetail
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfIntermediaryClientPlanDetail
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfIntermediaryClientPlanDetail
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfListOfIntermediaryClientPlanDetail
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfListOfIntermediaryClientPlanDetail
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<IntermediaryClientPlanDetail>}
     * @memberof ResultOfListOfIntermediaryClientPlanDetail
     */
    data?: Array<IntermediaryClientPlanDetail>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfIntermediaryClientPlanDetail
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfListOfIntermediaryClientPlanDetail interface.
 */
export function instanceOfResultOfListOfIntermediaryClientPlanDetail(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfListOfIntermediaryClientPlanDetailFromJSON(json: any): ResultOfListOfIntermediaryClientPlanDetail {
    return ResultOfListOfIntermediaryClientPlanDetailFromJSONTyped(json, false);
}

export function ResultOfListOfIntermediaryClientPlanDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfListOfIntermediaryClientPlanDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(IntermediaryClientPlanDetailFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfListOfIntermediaryClientPlanDetailToJSON(value?: ResultOfListOfIntermediaryClientPlanDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(IntermediaryClientPlanDetailToJSON)),
        'Count': value.count,
    };
}

